import ShellyBirthday2026Modal from 'src/components/Modals/ShellyBirthday2026Modal.svelte';
import { PROMOTIONS } from 'src/constants';
import { profile_data } from 'src/stores';
import { get } from 'svelte/store';

export const ShellyBirthday2026ModalConfig = (forceShow = false) => {
	return {
		id: 'shellyBirthday2026',
		component: ShellyBirthday2026Modal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const hasBeenSeen = !!get(profile_data)?.promotions?.shellyBirthday2026;

					return (
						now >= PROMOTIONS.SHELLY_BIRTHDAY_2026.START_DATE &&
						now < PROMOTIONS.SHELLY_BIRTHDAY_2026.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
